import * as d3 from 'd3';
export function sanitiseDomain(domain) {
    var min = domain[0], max = domain[1];
    if (min === undefined || max === undefined) {
        throw Error('domain is undefined');
    }
    return [min, max];
}
export function multiYExtent(lines, accessors, active) {
    var series = active !== undefined && active.size > 0
        ? lines.filter(function (l) { return active.has(accessors.key(l)); })
        : lines;
    var domain = series.reduce(function (collection, line) {
        var yDomain = d3.extent(accessors.data(line).map(accessors.y));
        if (yDomain[0] !== undefined && yDomain[1] !== undefined) {
            collection.push.apply(collection, yDomain);
        }
        return collection;
    }, []);
    // Catch error and return valid [0, 0] range.
    // This will occur if all series of a chart are invalid or empty
    try {
        var sanitised = sanitiseDomain(d3.extent(domain));
        return sanitised;
    }
    catch (_err) {
        // This is an expected state, so warning instead of erroring
        console.warn('All series are empty');
        return undefined;
    }
}
//# sourceMappingURL=multiYExtent.js.map